import queryString, { type ParseOptions, type StringifyOptions } from 'query-string';

export const queryStringToObject = <S extends object>(str: string, options: ParseOptions = {}): S =>
  queryString.parse(str, {
    arrayFormat: 'bracket',
    ...options,
  }) as S;

export const objectToQueryString = <S extends object>(
  queryObj: S,
  options: StringifyOptions = {},
): string =>
  queryString.stringify(queryObj, {
    arrayFormat: 'bracket',
    ...options,
  });
